import { provideSingleton, inject } from '../utils/decorators';
import { action, observable } from 'mobx';
import { AuftragStore } from './AuftragStore';
import { VorgangStore } from './VorgangStore';

/**
 * Singleton Basisklasse für globale Eigenschaften zu einem Kalibrierverfahren
 */
@provideSingleton(KalibrierungStore)
export class KalibrierungStore {

  @inject(AuftragStore) auftragStore: AuftragStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;

  @observable readOnly: boolean = false;

  @action setReadOnly(value: boolean) {
    this.readOnly = value;
  }

  /**
   * Gibt den zu verwendenden Kalibriergegenstand (Objekt) zurück
   * Entweder aus dem Vorgang oder dem Auftrag, Objekte im Vorgang haben Priorität
   */
  getKalibrierGegenstand() {
    const { vorgang } = this.vorgangStore;
    const { auftrag } = this.auftragStore;
    if (vorgang && vorgang.objekte && vorgang.objekte.length > 0) {
      return vorgang.objekte[0];
    }
    if (auftrag && auftrag.objekte && auftrag.objekte.length > 0) {
      return auftrag.objekte[0];
    }
    return undefined;
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/stores/KalibrierungStore.ts